import { ajaxClient as client } from '@/api/client'
import { ReelsList } from '@/entities/reels'

export async function fetchReels() {
    return await client.get<ReelsList>(`/reels`)
}
